(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[405],{

/***/ 21086:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(24041);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 24041:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ index_page; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../@core-shop/components/index.ts + 32 modules
var components = __webpack_require__(35284);
// EXTERNAL MODULE: ./src/providers/AuthProvider/authContext.ts
var authContext = __webpack_require__(33055);
// EXTERNAL MODULE: ../@shared-tailwind/atoms/Container/Container.tsx
var Container = __webpack_require__(33520);
// EXTERNAL MODULE: ../@shared-tailwind/atoms/InternalLink/InternalLink.tsx
var InternalLink = __webpack_require__(97084);
// EXTERNAL MODULE: ../@shared-tailwind/atoms/Banner/Banner.tsx
var Banner = __webpack_require__(7844);
// EXTERNAL MODULE: ../@shared-tailwind/molecules/SearchInput/SearchInput.tsx + 2 modules
var SearchInput = __webpack_require__(74795);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/@heroicons/react/outline/esm/BellIcon.js
var BellIcon = __webpack_require__(73196);
;// CONCATENATED MODULE: ../../node_modules/@heroicons/react/outline/esm/CreditCardIcon.js


function CreditCardIcon(props, svgRef) {
  return /*#__PURE__*/react.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 2,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef
  }, props), /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z"
  }));
}

const ForwardRef = react.forwardRef(CreditCardIcon);
/* harmony default export */ var esm_CreditCardIcon = (ForwardRef);
;// CONCATENATED MODULE: ../../node_modules/@heroicons/react/outline/esm/UserIcon.js


function UserIcon(props, svgRef) {
  return /*#__PURE__*/react.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 2,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef
  }, props), /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
  }));
}

const UserIcon_ForwardRef = react.forwardRef(UserIcon);
/* harmony default export */ var esm_UserIcon = (UserIcon_ForwardRef);
// EXTERNAL MODULE: ../@shared/utils/routes.tsx + 2 modules
var routes = __webpack_require__(89117);
// EXTERNAL MODULE: ../@shared-tailwind/atoms/Loader/Loader.tsx
var Loader = __webpack_require__(87864);
// EXTERNAL MODULE: ../@shared-tailwind/molecules/AvatarWithText/AvatarWithText.tsx
var AvatarWithText = __webpack_require__(8823);
;// CONCATENATED MODULE: ../@shared-tailwind/organisms/ShopHeader/ShopHeader.tsx






var ShopHeader = function(param) {
    var amountRaised = param.amountRaised, logo = param.logo, name = param.name, isLoading = param.isLoading, hasUser = param.hasUser;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "w-full py-3 bg-gray-100",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* Container */.W, {
            className: "flex justify-between items-center",
            children: [
                isLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Loader/* Loader */.a, {
                    size: 48
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(AvatarWithText/* AvatarWithText */.X, {
                    isCentered: true,
                    avatarProps: {
                        className: "border rounded-full bg-gray-300"
                    },
                    avatarSize: 10,
                    src: logo.split("?")[0],
                    textBottom: /*#__PURE__*/ (0,jsx_runtime.jsx)(InternalLink/* InternalLink */.h, {
                        className: "text-lg text-primary-500",
                        href: routes/* shopcloud.funds */.nR.funds(),
                        children: amountRaised
                    }),
                    textTop: name
                }),
                hasUser && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex space-x-3 text-gray-400",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(InternalLink/* InternalLink */.h, {
                            href: routes/* shopcloud.news */.nR.news(),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BellIcon/* default */.Z, {
                                className: "w-7 h-7"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(InternalLink/* InternalLink */.h, {
                            href: routes/* shopcloud.wallet */.nR.wallet(),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_CreditCardIcon, {
                                className: "w-7 h-7"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(InternalLink/* InternalLink */.h, {
                            href: routes/* shopcloud.teamDashboard */.nR.teamDashboard(),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_UserIcon, {
                                className: "w-7 h-7"
                            })
                        })
                    ]
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ../@shared-tailwind/atoms/HorizontalScroll/HorizontalScroll.tsx
var HorizontalScroll = __webpack_require__(87782);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(26297);
// EXTERNAL MODULE: ../../node_modules/classnames/index.js
var classnames = __webpack_require__(72779);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ../@shared-tailwind/atoms/Button/Button.tsx
var Button = __webpack_require__(2150);
// EXTERNAL MODULE: ../@shared-tailwind/types/buttons.ts
var buttons = __webpack_require__(49614);
;// CONCATENATED MODULE: ../@shared-tailwind/atoms/Shortcut/Shortcut.tsx








var Shortcut = function(_param) {
    var className = _param.className, props = (0,_object_without_properties/* default */.Z)(_param, [
        "className"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        className: classnames_default()("text-primary-500 border px-4 min-w-[100px] rounded-lg whitespace-nowrap", className),
        isRounded: false,
        size: buttons/* ButtonSizes.sm */.P.sm,
        variant: Button/* ButtonVariants.link */.c.link
    }));
};

;// CONCATENATED MODULE: ../@shared-tailwind/organisms/ShopShortcuts/ShopShortcuts.tsx



var ShopShortcuts = function(param) {
    var shortcutsQuery = param.shortcutsQuery, shortcuts = param.shortcuts;
    if (shortcutsQuery.isLoading) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(HorizontalScroll/* HorizontalScroll */.Z, {
        className: "px-3 py-5",
        children: shortcuts.map(function(param) {
            var name = param.name, shortcutUrl = param.shortcutUrl, id = param.id;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(InternalLink/* InternalLink */.h, {
                href: shortcutUrl !== null && shortcutUrl !== void 0 ? shortcutUrl : "",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Shortcut, {
                    children: name
                })
            }, "shortcut-".concat(id));
        })
    });
};

// EXTERNAL MODULE: ../../node_modules/tailwindcss/colors.js
var colors = __webpack_require__(6692);
var colors_default = /*#__PURE__*/__webpack_require__.n(colors);
// EXTERNAL MODULE: ../@shared-tailwind/atoms/BrandCircle/BrandCircle.tsx
var BrandCircle = __webpack_require__(99499);
// EXTERNAL MODULE: ../@shared-tailwind/molecules/BlocksCarousel/BlocksCarousel.tsx
var BlocksCarousel = __webpack_require__(740);
;// CONCATENATED MODULE: ../@shared-tailwind/organisms/ShopFavorites/ShopFavoritesWidget.tsx






var MIN_CIRCLES = 4;
var ShopFavoritesWidget = function(param) {
    var brands = param.brands, isLoading = param.isLoading;
    var _logoBackgroundColor;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(BlocksCarousel/* BlocksCarousel */.Y, {
        buttonTitle: "See all",
        buttonUrl: routes/* shopcloud.favorites */.nR.favorites(),
        className: "py-3",
        title: "Favorites",
        children: [
            isLoading && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mt-5 min-h-[100px]",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Loader/* Loader */.a, {
                    size: 60
                })
            }),
            brands.map(function(param) {
                var id = param.id, images = param.images, name = param.name;
                /*#__PURE__*/ return (0,jsx_runtime.jsx)(BrandCircle/* BrandCircle */.Z, {
                    bgColor: (_logoBackgroundColor = images.logoBackgroundColor) !== null && _logoBackgroundColor !== void 0 ? _logoBackgroundColor : (colors_default()).white,
                    href: routes/* shopcloud.brandModal */.nR.brandModal(id),
                    name: name,
                    src: (images === null || images === void 0 ? void 0 : images.invertedLogo) || images.logo || ""
                }, id);
            }),
            !isLoading && brands.length < MIN_CIRCLES && Array(MIN_CIRCLES - brands.length).fill("empty").map(function(name, i) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(BrandCircle/* BrandCircle */.Z, {
                    bgColor: (colors_default()).gray[100],
                    href: routes/* shopcloud.favorites */.nR.favorites(),
                    name: name
                }, "".concat(name, "-").concat(i));
            })
        ]
    });
};

;// CONCATENATED MODULE: ../@shared-tailwind/organisms/ShopNearby/ShopNearby.tsx






var ShopNearby_MIN_CIRCLES = 4;
var ShopNearby = function(param) {
    var locationSearchQuery = param.locationSearchQuery, _formattedBrands = param.formattedBrands, formattedBrands = _formattedBrands === void 0 ? [] : _formattedBrands;
    var _logoBackgroundColor;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(BlocksCarousel/* BlocksCarousel */.Y, {
        buttonTitle: "See all",
        buttonUrl: "#",
        className: "py-3",
        title: "Nearby",
        children: [
            locationSearchQuery.isLoading && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mt-5 min-h-[100px]",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Loader/* Loader */.a, {
                    size: 60
                })
            }),
            formattedBrands === null || formattedBrands === void 0 ? void 0 : formattedBrands.map(function(param) {
                var id = param.id, images = param.images, name = param.name, location = param.location;
                /*#__PURE__*/ return (0,jsx_runtime.jsx)(BrandCircle/* BrandCircle */.Z, {
                    bgColor: (_logoBackgroundColor = images.logoBackgroundColor) !== null && _logoBackgroundColor !== void 0 ? _logoBackgroundColor : (colors_default()).white,
                    href: routes/* shopcloud.brandModal */.nR.brandModal(id, location === null || location === void 0 ? void 0 : location.id),
                    name: name,
                    src: (images === null || images === void 0 ? void 0 : images.invertedLogo) || images.logo || ""
                }, id);
            }),
            !locationSearchQuery.isLoading && formattedBrands.length < ShopNearby_MIN_CIRCLES && Array(ShopNearby_MIN_CIRCLES - formattedBrands.length).fill("empty").map(function(name, i) {
                return(// eslint-disable-next-line react/no-array-index-key
                /*#__PURE__*/ (0,jsx_runtime.jsx)(BrandCircle/* BrandCircle */.Z, {
                    bgColor: (colors_default()).gray[100],
                    name: name
                }, "".concat(name, "-").concat(i)));
            })
        ]
    });
};

// EXTERNAL MODULE: ../@shared/utils/getUrlFromAssetDestination.ts
var getUrlFromAssetDestination = __webpack_require__(85179);
// EXTERNAL MODULE: ../@shared/utils/getDaysAgo.ts + 2 modules
var getDaysAgo = __webpack_require__(11700);
// EXTERNAL MODULE: ../@shared-tailwind/atoms/Slider/Slider.tsx
var Slider = __webpack_require__(51137);
// EXTERNAL MODULE: ../@shared-tailwind/atoms/NewsBlock/NewsBlock.tsx + 2 modules
var NewsBlock = __webpack_require__(30511);
// EXTERNAL MODULE: ../@shared-tailwind/molecules/HeadingSection/HeadingSection.tsx
var HeadingSection = __webpack_require__(22562);
;// CONCATENATED MODULE: ../@shared-tailwind/organisms/ShopNews/ShopNewsCarousel.tsx





var MAX_COUNT = 5;
var ShopNewsCarousel = function(param) {
    var newsQuery = param.newsQuery, news = param.news, onLikeNewsMutation = param.onLikeNewsMutation;
    if (newsQuery.isLoading) return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "mt-5 min-h-[100px]",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Loader/* Loader */.a, {
            size: 60
        })
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HeadingSection/* HeadingSection */.R, {
                hasNoBorder: true,
                children: "Just for you"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Slider/* Slider */.i, {
                children: news === null || news === void 0 ? void 0 : news.slice(0, MAX_COUNT).map(function(param) {
                    var id = param.id, details = param.details, isLiked = param.viewerHasLiked, time = param.time, likesCount = param.likesCount;
                    var _destination;
                    var destinationParsed = (0,getUrlFromAssetDestination/* getUrlFromAssetDestination */.m)((_destination = details.destination) !== null && _destination !== void 0 ? _destination : "");
                    var _description, _ctaText, _photoImage;
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* Container */.W, {
                        className: "py-4 border rounded-lg bg-gray-100",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NewsBlock/* NewsBlock */.I, {
                            body: (_description = details.description) !== null && _description !== void 0 ? _description : "",
                            buttonText: (_ctaText = details.ctaText) !== null && _ctaText !== void 0 ? _ctaText : "",
                            buttonUrl: destinationParsed.toString(),
                            className: "w-full h-[470px] flex flex-col",
                            date: (0,getDaysAgo/* getDaysAgo */.U)(time),
                            id: id,
                            imageSrc: (_photoImage = details.photoImage) !== null && _photoImage !== void 0 ? _photoImage : "",
                            isLiked: isLiked,
                            likesCount: likesCount,
                            onLikeNewsMutation: onLikeNewsMutation
                        })
                    }, id);
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ../@shared-tailwind/organisms/ShopStorefront/ShopStorefront.tsx
var ShopStorefront = __webpack_require__(8482);
// EXTERNAL MODULE: ../@shared/utils/constants.tsx
var constants = __webpack_require__(33323);
;// CONCATENATED MODULE: ./src/pages/index.page.tsx







var pageConfig = {
    theme: "SHOP_NEW",
    hasGraphql: false
};
Index.pageConfig = pageConfig;
function Index() {
    var ref = (0,authContext/* useAuthContext */.Eu)(), isAuthorized = ref.isAuthorized, shouldOptIn = ref.shouldOptIn;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* AuthenticatedHeader */.VU, {
                isAuthorized: isAuthorized,
                View: ShopHeader
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "bg-gray-100 pb-3 mb-5",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* Container */.W, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(InternalLink/* InternalLink */.h, {
                        shallow: true,
                        href: routes/* shopcloud.searchModal */.nR.searchModal(),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchInput/* SearchInput */.M, {
                            placeholder: "Search"
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* Container */.W, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Banner/* Banner */.j, {
                    className: "aspect-[4/3] bg-slate-100",
                    name: "Test banner",
                    src: constants/* DEFAULT_ORG_IMAGE_URL */.F$
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* Container */.W, {
                className: "border-y mt-6",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Shortcuts */.fQ, {
                    View: ShopShortcuts
                })
            }),
            isAuthorized && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* Container */.W, {
                        className: "border-b",
                        children: !shouldOptIn && /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Favorites */.Wv, {
                            View: ShopFavoritesWidget
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* Container */.W, {
                        className: "border-b",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* NearbyWidget */.wr, {
                            View: ShopNearby
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* Container */.W, {
                        className: "border-b my-6",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* News */.Sq, {
                            View: ShopNewsCarousel
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Storefront */.BT, {
                View: ShopStorefront/* ShopStorefront */.v
            })
        ]
    });
}
/* harmony default export */ var index_page = (Index);


/***/ }),

/***/ 76012:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "qE": function() { return /* binding */ Avatar; },
/* harmony export */   "wC": function() { return /* binding */ avatarSizes; }
/* harmony export */ });
/* unused harmony export AvatarNotificationColors */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(70865);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var _shared_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(33323);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(72779);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _Image_Image__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(33686);






// == Types ================================================================
var avatarSizes = [
    6,
    8,
    10,
    12,
    14,
    16,
    24,
    32
];
var AvatarNotificationColors;
(function(AvatarNotificationColors) {
    AvatarNotificationColors["gray"] = "gray";
    AvatarNotificationColors["green"] = "green";
    AvatarNotificationColors["red"] = "red";
})(AvatarNotificationColors || (AvatarNotificationColors = {}));
// == Constants ============================================================
Avatar.defaultProps = {
    src: _shared_utils__WEBPACK_IMPORTED_MODULE_3__/* .PLACEHOLDER_AVATAR */ .$c,
    notificationColor: AvatarNotificationColors.red,
    size: 10
};
// == Functions ============================================================
function useAvatarSizes(size) {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(0), pixelsSize = ref[0], setPixelsSize = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(""), classes = ref1[0], setClasses = ref1[1];
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        var avatarSize = size;
        setPixelsSize(avatarSize * 4);
        setClasses("h-".concat(avatarSize, " w-").concat(avatarSize));
    }, [
        size
    ]);
    return {
        pixelsSize: pixelsSize,
        classes: classes
    };
}
// == Component ============================================================
function Avatar(param) {
    var src = param.src, isRect = param.isRect, hasNotification = param.hasNotification, notificationColor = param.notificationColor, size = param.size, className = param.className, onClick = param.onClick, alt = param.alt;
    var ref = useAvatarSizes(size), classes = ref.classes, pixelsSize = ref.pixelsSize;
    var isBasicSrc = !src || typeof src === "string";
    var AvatarImage = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        if (isBasicSrc) return function(props) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Image_Image__WEBPACK_IMPORTED_MODULE_4__/* .Image */ .E, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                alt: "avatar"
            }, props));
        };
        var Icon = src;
        return function(props) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Icon, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, props));
        };
    }, [
        isBasicSrc,
        src
    ]);
    var hasIconSrc = src && typeof src !== "string";
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("relative flex items-center shrink-0", !onClick && "cursor-default", className),
        role: "button",
        tabIndex: -1,
        onClick: onClick,
        onKeyPress: onClick,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(AvatarImage, {
                alt: alt,
                className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("inline-block ", !hasIconSrc && {
                    "rounded-full": !isRect,
                    "rounded-md": isRect
                }, classes),
                imagePositionClassName: "object-cover object-center",
                imageProps: {
                    className: classnames__WEBPACK_IMPORTED_MODULE_2___default()(classes, "rounded-full"),
                    width: pixelsSize,
                    height: pixelsSize
                },
                src: isBasicSrc ? src || _shared_utils__WEBPACK_IMPORTED_MODULE_3__/* .PLACEHOLDER_AVATAR */ .$c : _shared_utils__WEBPACK_IMPORTED_MODULE_3__/* .PLACEHOLDER_AVATAR */ .$c
            }),
            hasNotification && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("absolute top-0 right-0 block h-2.5 w-2.5", "rounded-full ring-2 ring-white h-", "bg-".concat(notificationColor, "-400"))
            })
        ]
    });
} // == Styles ===============================================================


/***/ }),

/***/ 30511:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "I": function() { return /* binding */ NewsBlock; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(98788);
// EXTERNAL MODULE: ../../node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(5163);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../@core-shop/types/index.ts + 2 modules
var types = __webpack_require__(90195);
;// CONCATENATED MODULE: ../../node_modules/@heroicons/react/outline/esm/ThumbUpIcon.js


function ThumbUpIcon(props, svgRef) {
  return /*#__PURE__*/react.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 2,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef
  }, props), /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M14 10h4.764a2 2 0 011.789 2.894l-3.5 7A2 2 0 0115.263 21h-4.017c-.163 0-.326-.02-.485-.06L7 20m7-10V5a2 2 0 00-2-2h-.095c-.5 0-.905.405-.905.905 0 .714-.211 1.412-.608 2.006L7 11v9m7-10h-2M7 20H5a2 2 0 01-2-2v-6a2 2 0 012-2h2.5"
  }));
}

const ForwardRef = react.forwardRef(ThumbUpIcon);
/* harmony default export */ var esm_ThumbUpIcon = (ForwardRef);
;// CONCATENATED MODULE: ../../node_modules/@heroicons/react/solid/esm/ThumbUpIcon.js


function ThumbUpIcon_ThumbUpIcon(props, svgRef) {
  return /*#__PURE__*/react.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef
  }, props), /*#__PURE__*/react.createElement("path", {
    d: "M2 10.5a1.5 1.5 0 113 0v6a1.5 1.5 0 01-3 0v-6zM6 10.333v5.43a2 2 0 001.106 1.79l.05.025A4 4 0 008.943 18h5.416a2 2 0 001.962-1.608l1.2-6A2 2 0 0015.56 8H12V4a2 2 0 00-2-2 1 1 0 00-1 1v.667a4 4 0 01-.8 2.4L6.8 7.933a4 4 0 00-.8 2.4z"
  }));
}

const ThumbUpIcon_ForwardRef = react.forwardRef(ThumbUpIcon_ThumbUpIcon);
/* harmony default export */ var solid_esm_ThumbUpIcon = (ThumbUpIcon_ForwardRef);
// EXTERNAL MODULE: ../@shared-tailwind/atoms/Button/Button.tsx
var Button = __webpack_require__(2150);
// EXTERNAL MODULE: ../@shared-tailwind/atoms/Image/Image.tsx + 1 modules
var Image = __webpack_require__(33686);
// EXTERNAL MODULE: ../@shared-tailwind/atoms/InternalLink/InternalLink.tsx
var InternalLink = __webpack_require__(97084);
;// CONCATENATED MODULE: ../@shared-tailwind/atoms/NewsBlock/NewsBlock.tsx










var NewsBlock = function(param) {
    var _date = param.date, date = _date === void 0 ? "" : _date, body = param.body, imageSrc = param.imageSrc, buttonText = param.buttonText, _className = param.className, className = _className === void 0 ? "w-[292px]" : _className, isLiked = param.isLiked, buttonUrl = param.buttonUrl, likesCount = param.likesCount, onLikeNewsMutation = param.onLikeNewsMutation, id = param.id;
    var ref = (0,react.useState)(isLiked), hasInnerLike = ref[0], setHasInnerLike = ref[1];
    var ref1 = (0,react.useState)(false), isInnerLikeLoading = ref1[0], setIsInnerLikeLoading = ref1[1];
    var ref2 = (0,react.useState)(likesCount), innerLikesCount = ref2[0], setInnerLikesCount = ref2[1];
    var onLike = (0,react.useCallback)(/*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var ref, data;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    setIsInnerLikeLoading(true);
                    return [
                        4,
                        onLikeNewsMutation === null || onLikeNewsMutation === void 0 ? void 0 : onLikeNewsMutation.mutateAsync({
                            activityId: id,
                            reactionType: hasInnerLike ? types/* ReactionType.DISLIKE */.lo.DISLIKE : types/* ReactionType.LIKE */.lo.LIKE
                        })
                    ];
                case 1:
                    data = _state.sent();
                    if ((data === null || data === void 0 ? void 0 : (ref = data.ActivityReactionCreate) === null || ref === void 0 ? void 0 : ref.__typename) !== "MutationError" && (data === null || data === void 0 ? void 0 : data.ActivityReactionCreate.id)) {
                        setHasInnerLike(data.ActivityReactionCreate.viewerHasLiked);
                        setInnerLikesCount(data.ActivityReactionCreate.likesCount);
                    }
                    setIsInnerLikeLoading(false);
                    return [
                        2
                    ];
            }
        });
    }), [
        hasInnerLike,
        id,
        onLikeNewsMutation
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: className,
        children: [
            imageSrc && /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* Image */.E, {
                alt: body,
                className: "w-full h-[300px] rounded-lg overflow-hidden",
                imagePositionClassName: "object-cover",
                imageProps: {
                    className: "w-full h-full rounded-b-lg"
                },
                src: imageSrc
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "text-gray-900 mt-4 line-clamp-4",
                children: body
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex-1 flex flex-col justify-end",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex justify-between items-center mt-4 ",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "text-gray-400",
                            children: date
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex space-x-2",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                                    resetSizeClasses: true,
                                    className: "px-2 py-1",
                                    Icon: hasInnerLike ? solid_esm_ThumbUpIcon : esm_ThumbUpIcon,
                                    iconClassName: "text-primary-500 w-6 h-6",
                                    isLoading: isInnerLikeLoading,
                                    variant: Button/* ButtonVariants.secondary */.c.secondary,
                                    onClick: onLike,
                                    children: !!innerLikesCount && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "text-gray-600",
                                        children: innerLikesCount
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(InternalLink/* InternalLink */.h, {
                                    href: buttonUrl !== null && buttonUrl !== void 0 ? buttonUrl : "",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                                        resetSizeClasses: true,
                                        className: "px-3 py-1",
                                        children: buttonText
                                    })
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};


/***/ }),

/***/ 8823:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X": function() { return /* binding */ AvatarWithText; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(70865);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var _shared_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(33323);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(72779);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _shared_tailwind_atoms__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(76012);





// == Constants ============================================================
AvatarWithText.defaultProps = {
    src: _shared_utils__WEBPACK_IMPORTED_MODULE_2__/* .PLACEHOLDER_AVATAR */ .$c,
    textTop: "",
    textBottom: "",
    avatarSize: 10
};
var sharedTextClasses = "text-left font-medium";
// == Component ============================================================
function AvatarWithText(param) {
    var src = param.src, avatarSize = param.avatarSize, textTop = param.textTop, textBottom = param.textBottom, textUppercased = param.textUppercased, className = param.className, CustomAvatar = param.CustomAvatar, avatarProps = param.avatarProps, isTruncated = param.isTruncated, isCentered = param.isCentered, onClick = param.onClick, _hasAvatar = param.hasAvatar, hasAvatar = _hasAvatar === void 0 ? true : _hasAvatar;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()("block text-sm", onClick && "cursor-pointer", className),
        role: "button",
        tabIndex: -1,
        onClick: onClick,
        onKeyPress: onClick,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: classnames__WEBPACK_IMPORTED_MODULE_1___default()("flex", {
                "items-center": !textTop || !textBottom || isCentered
            }),
            children: [
                hasAvatar && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "shrink-0",
                    children: CustomAvatar !== null && CustomAvatar !== void 0 ? CustomAvatar : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_shared_tailwind_atoms__WEBPACK_IMPORTED_MODULE_3__/* .Avatar */ .qE, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
                        size: avatarSize,
                        src: src
                    }, avatarProps))
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: classnames__WEBPACK_IMPORTED_MODULE_1___default()("w-full", hasAvatar && "ml-3"),
                    children: [
                        textUppercased && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: classnames__WEBPACK_IMPORTED_MODULE_1___default()(sharedTextClasses, "text-xs text-gray-500 uppercase", isTruncated && "whitespace-nowrap truncate"),
                            children: textUppercased
                        }),
                        textTop && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: classnames__WEBPACK_IMPORTED_MODULE_1___default()(sharedTextClasses, "text-gray-700", isTruncated && "whitespace-nowrap truncate"),
                            children: textTop
                        }),
                        textBottom && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: classnames__WEBPACK_IMPORTED_MODULE_1___default()(sharedTextClasses, "text-xs text-gray-500", isTruncated && "whitespace-nowrap truncate"),
                            children: textBottom
                        })
                    ]
                })
            ]
        })
    });
} // == Styles ===============================================================


/***/ }),

/***/ 8482:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "v": function() { return /* binding */ ShopStorefront; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var _shared_hooks__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(68903);
/* harmony import */ var _shared_tailwind_atoms__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(33520);
/* harmony import */ var _shared_tailwind_atoms__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(87864);
/* harmony import */ var _shared_tailwind_molecules__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(32004);
/* harmony import */ var _ShopCollection_ShopCollection__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(21497);






var ShopStorefront = function(param) {
    var collections = param.collections, hasHeader = param.hasHeader, title = param.title, storefrontQuery = param.storefrontQuery, toggleFavoriteMutation = param.toggleFavoriteMutation, shouldShowLikeButton = param.shouldShowLikeButton;
    var router = (0,_shared_hooks__WEBPACK_IMPORTED_MODULE_2__/* .useRouter */ .t)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            hasHeader && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_shared_tailwind_molecules__WEBPACK_IMPORTED_MODULE_3__/* .BackTopNav */ .n, {
                hasBackText: false,
                hasBottomSpace: false,
                title: title,
                onClick: router.safeBack
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_shared_tailwind_atoms__WEBPACK_IMPORTED_MODULE_4__/* .Container */ .W, {
                className: "pb-10",
                children: [
                    storefrontQuery.isLoading && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "flex justify-center",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_shared_tailwind_atoms__WEBPACK_IMPORTED_MODULE_5__/* .Loader */ .a, {
                            size: 96
                        })
                    }),
                    collections.map(function(collection) {
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ShopCollection_ShopCollection__WEBPACK_IMPORTED_MODULE_6__/* .ShopCollection */ .e, {
                            collection: collection,
                            shouldShowLikeButton: !!shouldShowLikeButton,
                            toggleFavoriteMutation: toggleFavoriteMutation
                        }, collection.id);
                    })
                ]
            })
        ]
    });
};


/***/ }),

/***/ 11700:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "U": function() { return /* binding */ getDaysAgo; }
});

// EXTERNAL MODULE: ../../node_modules/date-fns/esm/_lib/getTimezoneOffsetInMilliseconds/index.js
var getTimezoneOffsetInMilliseconds = __webpack_require__(1645);
// EXTERNAL MODULE: ../../node_modules/date-fns/esm/toDate/index.js
var toDate = __webpack_require__(66700);
// EXTERNAL MODULE: ../../node_modules/date-fns/esm/_lib/requiredArgs/index.js
var requiredArgs = __webpack_require__(19785);
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/startOfDay/index.js


/**
 * @name startOfDay
 * @category Day Helpers
 * @summary Return the start of a day for the given date.
 *
 * @description
 * Return the start of a day for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the start of a day
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The start of a day for 2 September 2014 11:55:00:
 * const result = startOfDay(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 02 2014 00:00:00
 */

function startOfDay(dirtyDate) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  var date = (0,toDate/* default */.Z)(dirtyDate);
  date.setHours(0, 0, 0, 0);
  return date;
}
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/differenceInCalendarDays/index.js



var MILLISECONDS_IN_DAY = 86400000;
/**
 * @name differenceInCalendarDays
 * @category Day Helpers
 * @summary Get the number of calendar days between the given dates.
 *
 * @description
 * Get the number of calendar days between the given dates. This means that the times are removed
 * from the dates and then the difference in days is calculated.
 *
 * @param {Date|Number} dateLeft - the later date
 * @param {Date|Number} dateRight - the earlier date
 * @returns {Number} the number of calendar days
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // How many calendar days are between
 * // 2 July 2011 23:00:00 and 2 July 2012 00:00:00?
 * const result = differenceInCalendarDays(
 *   new Date(2012, 6, 2, 0, 0),
 *   new Date(2011, 6, 2, 23, 0)
 * )
 * //=> 366
 * // How many calendar days are between
 * // 2 July 2011 23:59:00 and 3 July 2011 00:01:00?
 * const result = differenceInCalendarDays(
 *   new Date(2011, 6, 3, 0, 1),
 *   new Date(2011, 6, 2, 23, 59)
 * )
 * //=> 1
 */

function differenceInCalendarDays(dirtyDateLeft, dirtyDateRight) {
  (0,requiredArgs/* default */.Z)(2, arguments);
  var startOfDayLeft = startOfDay(dirtyDateLeft);
  var startOfDayRight = startOfDay(dirtyDateRight);
  var timestampLeft = startOfDayLeft.getTime() - (0,getTimezoneOffsetInMilliseconds/* default */.Z)(startOfDayLeft);
  var timestampRight = startOfDayRight.getTime() - (0,getTimezoneOffsetInMilliseconds/* default */.Z)(startOfDayRight); // Round the number of days to the nearest integer
  // because the number of milliseconds in a day is not constant
  // (e.g. it's different in the day of the daylight saving time clock shift)

  return Math.round((timestampLeft - timestampRight) / MILLISECONDS_IN_DAY);
}
// EXTERNAL MODULE: ../../node_modules/date-fns/esm/parseISO/index.js + 1 modules
var parseISO = __webpack_require__(85488);
;// CONCATENATED MODULE: ../@shared/utils/getDaysAgo.ts
// eslint-disable-next-line import/no-duplicates

// eslint-disable-next-line import/no-duplicates

function getDaysAgo(timeISO) {
    var daysAgo = Math.abs(differenceInCalendarDays((0,parseISO/* default */.Z)(timeISO), new Date()));
    var dateString = "";
    switch(daysAgo){
        case 0:
            dateString = "today";
            break;
        case 1:
            dateString = "yesterday";
            break;
        default:
            dateString = "".concat(daysAgo, " days ago");
    }
    return dateString;
}


/***/ }),

/***/ 73196:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);


function BellIcon(props, svgRef) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 2,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef
  }, props), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9"
  }));
}

const ForwardRef = react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(BellIcon);
/* harmony default export */ __webpack_exports__["Z"] = (ForwardRef);

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [830,497,774,888,179], function() { return __webpack_exec__(21086); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);